var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkLarge = function SvgCheckmarkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.956 14.607-2.32-2.32a1.71 1.71 0 0 0-2.424 0 1.714 1.714 0 0 0 0 2.425l3.54 3.54c.67.67 1.754.67 2.425 0l9.985-9.985c.67-.67.67-1.754 0-2.425a1.71 1.71 0 0 0-2.425 0z"
  })));
};
export default SvgCheckmarkLarge;